import type { ScreenTourMap } from './types';

/** Préstamos › Abonos y préstamos. */
export const loanTours: ScreenTourMap = {
  '/loans/payments': {
    key: 'screen-loan-payments',
    steps: [
      { text: 'tours.loanPayments.welcome' },
      { text: 'tours.loanPayments.office', target: 'loan-payments-office' },
      { text: 'tours.loanPayments.route', target: 'loan-payments-route' },
      { text: 'tours.loanPayments.newLoan', target: 'loan-payments-new-loan' },
      { text: 'tours.loanPayments.addClient', target: 'loan-payments-add-client' },
      { text: 'tours.loanPayments.deleteSelected', target: 'loan-payments-delete-selected' },
      { text: 'tours.loanPayments.stats', target: 'loan-payments-stats', whenMissing: 'center' },
      { text: 'tours.loanPayments.search', target: 'loan-payments-search' },
      { text: 'tours.loanPayments.table', target: 'loan-payments' },
      { text: 'tours.loanPayments.daysLate', target: 'loan-payments-col-daysLate' },
      { text: 'tours.loanPayments.paidToday', target: 'loan-payments-col-paidToday' },
      { text: 'tours.loanPayments.actions', target: 'loan-payments-actions' },
      { text: 'tours.loanPayments.export', target: 'loan-payments-export' },
    ],
  },
};
